import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpContext,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { SessionStorageService } from '@app/core/auth/session-storage';
import { WindowRef } from '@app/core/providers/window-ref';

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  constructor(
    private http: HttpClient,
    private router: Router,
    public sessionStorageService: SessionStorageService,
    private windowRef: WindowRef,
  ) {}

  get<T>(url: string, options?: { headers?: HttpHeaders }): Observable<T> {
    const timestamp = new Date().toISOString();
    return this.http.get<T>(url, options).pipe(
      catchError((error: HttpErrorResponse) => {
        this.handleError('GET', url, timestamp, error);
        return throwError(() => error);
      }),
    );
  }

  patch<T>(url: string, body: Record<string, unknown>): Observable<T> {
    const timestamp = new Date().toISOString();
    return this.http.patch<T>(url, body).pipe(
      catchError((error: HttpErrorResponse) => {
        this.handleError('PATCH', url, timestamp, error, body);
        return throwError(() => error);
      }),
    );
  }

  post<T>(
    url: string,
    body: Record<string, unknown> | null,
    options?: { headers?: HttpHeaders; context?: HttpContext },
  ): Observable<T> {
    const timestamp = new Date().toISOString();
    return this.http.post<T>(url, body, options).pipe(
      catchError((error: HttpErrorResponse) => {
        this.handleError('POST', url, timestamp, error, body ?? undefined);
        return throwError(() => error);
      }),
    );
  }

  private handleError(
    method: string,
    url: string,
    timestamp: string,
    error: HttpErrorResponse,
    body?: Record<string, unknown>,
  ): void {
    if (error.status === 401) {
      this.sessionStorageService.logout();
      this.windowRef.href = `${environment.cgwAuthWebUrl}?applicationCode=${environment.applicationName}#redirectUrl=${this.windowRef.href}`;
      return;
    }

    if (method === 'PATCH' || method === 'POST') {
      console.error(
        `[HTTP ERROR] ${method} ${url} -> ${error.status} ${error.message} @ ${timestamp}`,
        { body },
      );
    } else {
      console.error(
        `[HTTP ERROR] ${method} ${url} -> ${error.status} @ ${timestamp}`,
      );
    }
  }
}
